import messages from "./pt_BR.js";

const dictionary = {
  pt_BR: {
    messages
  }
};

export default dictionary;



// WEBPACK FOOTER //
// ./src/components/Validators/dictionary.js